<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">제목</td>
                <td>
                    <div>
                        {{ itemData.i_name }}
                    </div>
                </td>
            </tr>

            <tr>
                <td class="c_t_title">썸네일</td>
                <td>
                    <div>

                        <img v-if="itemData.hasOwnProperty('ItemFile')" :src="itemData.ItemFile.Item[0].org_url"
                             style="width: 278px; height: 384px;">
                    </div>
                </td>
            </tr>

            <tr>
                <td class="c_t_title">타입</td>
                <td>
                    <div>
                        <span>{{ returnItemType(itemData.i_type) }}</span>

                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">카테고리</td>
                <td>
                    <div>
                        {{ itemData.ic_name }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">에디션</td>
                <td>
                    <div>
                        {{ returnEditionType() }}

                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">보증서 / 감정서</td>
                <td>
                    <div v-if="itemData.hasOwnProperty('ItemFile')"
                         v-for="(data,index) in GuarantyFile"
                         :key="`guranty${index}`"
                         @click="awsS3Download('guaranty' ,data,itemData.i_idx)">
                        {{ data.org_name }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">원본</td>
                <td>
                    <div v-if="NFTFile.length>0" class="hover"
                         @click="awsS3Download('original', NFTFile[0],itemData.i_idx,true)
                                        ">
                        {{ NFTFile[0].a_filename }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">창작자</td>
                <td>
                    <div>
                        <span class="hover" @click="movePage(`/member/detail/${itemData.im_originator}`)">
                            {{ returnName(itemData.original_nick) }}
                        </span>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">소유자</td>
                <td>
                    <div>
                        <span class="hover"
                              @click="movePage(`/member/detail/${itemData.provider}`)">
                            {{ returnName(itemData.provider_nick) }}
                        </span>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">큐레이터</td>
                <td>
                    <div>
                      <span class="hover"
                            @click="movePage(`/member/detail/${itemData.curator}`)">
                            {{ returnName(itemData.curator_nick) }}
                      </span>
                    </div>
                </td>
            </tr>
            <tr v-if="itemData.ic_idx == 2">
                <td class="c_t_title">AI생성여부</td>
                <td>
                    <div>
                      <span class="hover">
                            {{ itemData.im_is_ai == 1 ? '예' : '아니오' }}
                      </span>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">컬렉션</td>
                <td>
                    <div>
                      <span class="hover" @click="movePage(`/item/collection/${itemData.Collection.c_idx}`)">
                            {{ returnCollection(itemData) }}
                      </span>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">세부정보</td>
                <td>
                    <div>
                        촬영일시: {{ returnTakenTime() }}<br/>
                        촬영국가: {{ itemData.imo_country }}<br/>
                        촬영시(도): {{ itemData.imo_si }}<br/>
                        촬영도시: {{ itemData.imo_city }}<br/>
                        사이즈: {{ itemData.imo_size }}<br/>
                        저작권정보: {{ itemData.imo_copyright }}<br/>
                    </div>
                </td>
            </tr>

        </table>
        <div class="sub_title mt10 mb10" v-if="itemData.Status">상태</div>
        <table v-if="returnStatus(itemData.im_status) === '판매안함' && itemData.Status">
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">상태</td>
                <td>
                    <div>
                        {{ returnStatus(itemData.im_status) }}
                    </div>
                </td>
            </tr>
        </table>
        <table v-if="returnStatus(itemData.im_status) === '공모전 응모' && itemData.Status">
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">상태</td>
                <td>
                    <div>
                        {{ returnStatus(itemData.im_status) }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">공모전</td>
                <td>
                    <div>
                        {{ itemData.Status.c_title }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">득표수</td>
                <td>
                    <div>
                        {{ returnCommas(itemData.Status.ci_vote_cnt) }}
                    </div>
                </td>
            </tr>
            <tr v-for="(judge,index) in itemData.Status.Judge" :key="`judge-${judge.cij_idx}`">
                <td class="c_t_title">심사위원평가 {{ index + 1 }}</td>
                <td>
                    <div>
                        <span>
                            {{ judge.mb_nick }}
                        </span>
                        <span>{{ judge.cij_score }}점</span>
                    </div>
                    <div>
                        {{ judge.cij_reason }}
                    </div>
                </td>
            </tr>
        </table>
        <table v-if="(returnStatus(itemData.im_status) === '지정가 판매'
            || returnStatus(itemData.im_status) === '프리미엄 지정가 판매')&& itemData.Status">
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">상태</td>
                <td>
                    <div>
                        {{ returnStatus(itemData.im_status) }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">판매가</td>
                <td>
                    <div>
                        {{ returnCommas(itemData.i_price) }}M
                    </div>
                </td>
            </tr>
        </table>
        <table v-if="(returnStatus(itemData.im_status) === '인수대기'
            || returnStatus(itemData.im_status) === '프리미엄 인수 대기')&& itemData.Status">
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">상태</td>
                <td>
                    <div>
                        {{ returnStatus(itemData.im_status) }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">구매자</td>
                <td>
                    <div>
                        {{ itemData.Status.m_bid_nick }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">강제처리</td>
                <td>
                    <div>
                        <el-button class="com_btn" @click="confirmItemSellingStatus('assumeItem')">인수완료</el-button>
                        <el-button class="com_del" @click="confirmItemSellingStatus('cancelItem')">거래파기</el-button>
                    </div>
                </td>
            </tr>
        </table>
        <table v-else-if="(returnStatus(itemData.im_status) === '경매' ||
        returnStatus(itemData.im_status) === '프리미엄 경매') && itemData.Status
        ">
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">상태</td>
                <td>
                    <div>
                        {{ returnStatus(itemData.im_status) }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">경매시작일자</td>
                <td>
                    <div>
                        {{ returnDateFormat(itemData.Status.ia_start_date, 'YYYY-MM-DD HH:mm') }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">경매종료일자</td>
                <td>
                    <div>
                        {{ returnDateFormat(itemData.Status.ia_end_date, 'YYYY-MM-DD HH:mm') }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">최소입찰가</td>
                <td>
                    <div>
                        {{ itemData.Status.m_minimum }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">즉시구매가</td>
                <td>
                    <div>
                        {{ itemData.Status.m_immediately }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">최고입찰가</td>
                <td>
                    <div>
                        {{ returnBidPrice() }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">경매내역</td>
                <td>
                    <div v-for="bid in returnBids()" :key="`bid-${bid.ab_idx}`" v-if="hasBids()">
                        {{
                            `${bid.ab_nick} 님이 ${returnCommas(bid.ab_bids)}Mg로 ${returnBidStatus(bid.ab_status)}하였습니다. ${returnDateFormat(bid.created_at, 'YYYY-MM-DD HH:mm:ss')}`
                        }}
                    </div>
                    <div>
                        {{ itemData.Status.m_nick }}님이 최소입찰가 {{ itemData.Status.m_minimum }}Mg ,즉시 구매가
                        {{ itemData.Status.m_immediately }}Mg로 경매를 개설하였습니다.
                        {{ returnDateFormat(itemData.Status.created_at, 'YYYY-MM-DD HH:mm:ss') }}
                    </div>
                </td>
            </tr>
        </table>
        <table v-else-if="returnStatus(itemData.im_status) === '라이선스'">
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">상태</td>
                <td>
                    <div>
                        {{ returnStatus(itemData.im_status) }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">판매가</td>
                <td>
                    <div>
                        {{ returnCommas(itemData.Status.il_original_price) }}M
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">엑스트라 라지</td>
                <td>
                    <div>
                        {{ returnCommas(itemData.Status.il_extra_large_price) }}M
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">라지</td>
                <td>
                    <div>
                        {{ returnCommas(itemData.Status.il_large_price) }}M
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">미디움</td>
                <td>
                    <div>
                        {{ returnCommas(itemData.Status.il_medium_price) }}M
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">스몰</td>
                <td>
                    <div>
                        {{ returnCommas(itemData.Status.il_small_price) }}M
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">라이선스 구매 주의사항</td>
                <td>
                    <div v-html="itemData.Status.il_caution"></div>
                </td>
            </tr>
        </table>
        <div class="sub_title mt10 mb10">블록체인등록정보</div>
        <table v-if="checkBlock()">
            <colgroup>
                <col width="200px;">
                <col width="">
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">CanBePawned</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.canBePawned }}
                    </div>
                </td>
                <td class="c_t_title">CanBeRented</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.canBeRented }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">CanBeSold</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.canBeSold }}
                    </div>
                </td>
                <td class="c_t_title">CreatedTimestamp</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.createdTimestamp }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">CurrentState</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.currentState }}
                    </div>
                </td>
                <td class="c_t_title">DivisibleNftParts</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.divisibleNftParts }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">EditionLimit</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.editionLimit }}
                    </div>
                </td>
                <td class="c_t_title">EditionName</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.editionName }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">EditionNumber</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.editionNumber }}
                    </div>
                </td>
                <td class="c_t_title">NftCreator</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.nftCreator }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">NftHash</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.nftHash }}
                    </div>
                </td>
                <td class="c_t_title">NftId</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.nftId }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">NftName</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.nftName }}
                    </div>
                </td>
                <td class="c_t_title">NftOwner</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.nftOwner }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">Price</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.price }}
                    </div>
                </td>
                <td class="c_t_title">Type</td>
                <td>
                    <div>
                        {{ itemData.BlockChain.type }}
                    </div>
                </td>
            </tr>
        </table>
        <div class="sub_title mt10 mb10">추가정보</div>
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">

            </colgroup>
            <tr>
                <td class="c_t_title">추가썸네일</td>
                <td>
                    <div @click="changeType('detailThumbnail')" class="inline-block">
                        <el-upload
                                class=" img_inputBox_wrap thumbImg mr20 "
                                action=""
                                list-type="picture"
                                :show-file-list="false"
                                :auto-upload="false"
                                :on-change="photoListChange"
                        >
                            <!--                            <i class="img_inputBox"></i>-->
                            <div class="img_inputBox"></div>
                        </el-upload>
                    </div>
                    <div class="img_inputBox_wrap thumbImg mr20 inline-block pt0"
                         v-for=" (thumb,index) in detailThumbnail" :key="`thumb-${index}`">
                        <img :src="thumb.org_url ? thumb.org_url : thumb.url" class="avatar">
                        <button class="cancelBtn"
                                @click="removeList('detailThumbnail',index)"></button>
                    </div>

                </td>
            </tr>
            <tr>
                <td class="c_t_title">성인인증 필요</td>
                <td>
                    <div>
                        <el-select v-model="isAdult" class="select faq_select mr5">
                            <el-option :value="0" :label="'아니오'"></el-option>
                            <el-option :value="1" :label="'예'"></el-option>
                        </el-select>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">해시태그(세부카테고리)</td>
                <td>
                    <div>
                        <el-select id="hash" v-model="hashData" class="w_content my_filter select mr10"
                                   placeholder="세부카테고리선택"
                                   popper-class="category_select"
                                   :popper-append-to-body="false"
                                   @change="changeHash(1,hashData)">
                            <el-option :value="data.node_id" v-for="data in detailCategories.child"
                                       :key="`item${data.node_id}`" :label="data.NAME">
                            </el-option>
                        </el-select>
                        <!--                        <span v-for="(hash,index) in returnHashSelect(itemData.Hash)" :key="`hash-${index}`">
                                                  #{{ hash }}
                                              </span>-->
                        <div v-for="(data,index) in hashtag" :key="`hash${index}`" v-if="data.type === 1"
                             class="inline-block mr10"
                        >
                            <div class="hash_wrap">
                                <span class="hash_name">{{ returnHashTag(data) }}</span>
                                <button class="delete_btn" @click="removeHash(index)"></button>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">해시태그(직접입력)</td>
                <td>
                    <el-input type="text" placeholder="직접입력" v-model="hashInput"
                              @input="setData('hashInput',hashInput)"
                              @keyup.enter.native="changeHash(2,hashInput)"
                              class="shortest mr10"/>
                    <el-button class="com_btn" @click="changeHash(2,hashInput)">입력</el-button>
                    <br>
                    <div v-for="(data,index) in hashtag" :key="`hash${index}`" v-if="data.type === 2"
                         class="inline-block mr10"
                    >
                        <div class="hash_wrap">
                            <span class="hash_name">{{ data.tag }}</span>
                            <button class="delete_btn" @click="removeHash(index)"></button>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">아이템설명</td>
                <td>
                    <quill-editor
                            ref="contentEditor"
                            class="h300"
                            v-model="memo"
                            :options="editorOption"
                    />
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import dateMixins from "@/mixins/dateMixins";
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";
import {itemStatus, itemCategory, itemEdition, itemType} from "@/service/itemService";
import elFileMixins from "@/mixins/elFileMixins";
import quillEditorMixins from "@/mixins/quillEditorMixins";
import EventBus from "@/utils/event-bus";
import awsS3FileDownload from "@/mixins/awsS3FileDownload";

export default {
    name: "ItemWriteDefaultLayout",
    mixins: [dateMixins, imageOption, elFileMixins, quillEditorMixins, awsS3FileDownload],
    components: {},
    inject: ['itemWriteSetData'],
    provide() {
        return {}
    },
    props: {
        itemData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        itemCategoryList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            categoryType: itemCategory,
            itemStatus: itemStatus,
            itemEdition: itemEdition,
            itemType: itemType,
            memo: '',
            isAdult: 0,
            detailThumbnail: [],
            hashData: '',
            detailCategories: [],
            hashtag: [],
            hashInput: '',
            deleteFiles: [],
            NFTFile: [],
            GuarantyFile: [],

        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        setTimeout(() => {
            if (this.hasData()) {
                this.initSetData();
            }
            setTimeout(() => {
                $('.contents_wrap').scrollTop(0);
            }, 100)
        }, 500)

    },
    beforeUpdate() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        hasData() {
            return !util.isEmpty(this.itemData)
        },
        initSetData() {
            this.thumbnail = this.itemData.ItemFile.Item;
            this.parentChange('thumbnail', this.thumbnail);
            this.isAdult = this.itemData.im_adult_chk
            this.parentChange('isAdult', this.isAdult);

            if (!util.isEmpty(this.itemData.ItemFile.Detail)) {
                this.detailThumbnail = this.itemData.ItemFile.Detail.filter(v => !util.isEmpty(v.a_idx));
                this.parentChange('detailThumbnail', this.detailThumbnail);
            }
            if (!util.isEmpty(this.itemData.ItemFile.NFT)) {
                this.NFTFile = this.itemData.ItemFile.NFT.filter(v => !util.isEmpty(v.a_idx));
                this.parentChange('NFTFile', this.NFTFile);
            }
            if (!util.isEmpty(this.itemData.ItemFile.Guaranty)) {
                this.GuarantyFile = this.itemData.ItemFile.Guaranty.filter(v => !util.isEmpty(v.a_idx));
                this.parentChange('GuarantyFile', this.GuarantyFile);
            }

            let categoryIndex = this.itemCategoryList.findIndex(category => category.node_id === this.itemData.ic_idx);
            this.detailCategories = this.itemCategoryList[categoryIndex];
            this.itemData.Hash.forEach(data => {
                let hash = {type: data.ih_type, tag: data.ih_hashtag}
                if (data.ih_type === 1) {
                    hash.tag = data.ic_idx;
                }
                this.hashtag.push(hash);
            })
            this.parentChange('hashtag', this.hashtag);
            this.memo = this.itemData.i_memo
            this.memo = util.htmlDecode(this.memo);

            this.parentChange('memo', this.memo);

        },
        checkBlock() {
            return !util.isEmpty(this.itemData.BlockChain);
        },
        parentChange(key, value) {
            if (key === 'content') {
                this.content = this.replaceN(value);
                value = this.content
            }
            this.itemWriteSetData(key, value)
        },


        returnCommas(x = 0) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        returnImage(image, width = 32, height = 32) {
            if (!util.isEmpty(image)) {
                return `${image[0].org_url}?${this.setImageOptions(width * 2, height * 2, 'jpg')}`
            }
            return ''
        },
        openImageFile(image) {
            let url = ''
            if (!util.isEmpty(image)) {
                url = image[0].org_url
            }
            window.open(url, '_blank');
        },
        returnItemType(value) {
            let keys = Object.keys(this.itemType)
            let key = keys.filter(type => type === value);
            if (util.isEmpty(key)) {
                return '-'
            }
            return this.itemType[key].name
        },
        returnEdition(value) {
            let keys = Object.keys(this.itemEdition)
            let key = keys.filter(edition => Number(edition) === value);
            if (util.isEmpty(key)) {
                return '-'
            }
            return this.itemEdition[key].name
        },
        returnEditionType() {

            if (this.itemData.im_edition === 1) {
                return `${this.itemData.im_count} / ${this.itemData.im_total}`
            } else {
                return this.returnEdition(this.itemData.im_edition)
            }
        },
        returnName(name) {
            return !util.isEmpty(name) ? name : '-'
        },
        returnTakenTime() {
            let time = this.itemData.imo_date
            let date = this.returnDateFormat(time, 'DD/MM/YYYY HH:mm:ss')
            if (!util.isEmpty(date) && date !== 'Invalid date') {
                return date
            } else {
                return ''
            }
        },
        movePage(url) {
            this.$router.push(url)
        },
        returnStatus(value) {
            let keys = Object.keys(this.itemStatus)
            let key = keys.filter(status => Number(status) === value);
            if (util.isEmpty(key)) {
                return '-'
            }
            return this.itemStatus[key].name

        },
        returnBidStatus(status) {
            switch (status) {
                case 0 : {
                    return '입찰실패'
                }
                case 1 : {
                    return '입찰'
                }
                case 2 : {
                    return '낙찰'
                }
                default : {
                    return ''
                }
            }
        },
        photoListChange(file, fileList) {
            if (this.detailThumbnail.length > 9) {
                this.errorAlert('더이상 이미지를 등록 할 수 없습니다(최대 10개)')
            } else {
                this.handleFileChange(file, fileList);
            }
        },
        removeList(type, index) {


            this.deleteFiles.push(this[type][index])
            this[type].splice(index, 1);
            this.parentChange(`${type}`, this[type])

            this.parentChange(`deleteFiles`, this.deleteFiles)
            this.$forceUpdate();
        },
        returnHashSelect(hashtag) {
            let list = []
            util.each(hashtag, (hash, index, arr) => {
                if (!util.isEmpty(hash.ic_name) && hash.ih_type === 1) {
                    list.push(hash.ic_name)
                }
            })
            return list
        },
        returnHashWrote(hashtag) {
            let list = []
            util.each(hashtag, (hash, index, arr) => {
                if (!util.isEmpty(hash.ih_hashtag) && hash.ih_type === 2) {
                    list.push(hash.ih_hashtag)
                }
            })
            return list
        },
        changeHash(key, value) {
            if (util.isEmpty(value)) {
                return false;
            }
            if (this.hashtag.length > 50) {
                this.errorAlert('해시태그는 50개까지 가능합니다.');
                return;
            }
            let hash = {type: key, tag: value};
            if (key === 1) {
                this.hashData = value;
            }
            let hashIndex = this.hashtag.findIndex(category => category.tag === value);
            if (hashIndex > -1) {
                return
            }
            this.hashtag.push(hash);
            this.parentChange('hashtag', this.hashtag);
            this.hashInput = "";
        },
        removeHash(index) {
            this.hashtag.splice(index, 1);
        },
        returnHashTag(data) {
            if (util.isEmpty(data) || util.isEmpty(this.detailCategories)) {
                return
            }
            let detailTag = Number(data.tag);
            let hashIndex = this.detailCategories.child.findIndex(category => category.node_id === detailTag);
            console.log(hashIndex)
            if (hashIndex > -1) {
                return this.detailCategories.child[hashIndex].NAME;
            }
        },
        setData(key, value) {
            this[key] = value
        },
        returnBids() {
            let arr = JSON.parse(JSON.stringify(this.itemData.Status.Bids))
            let reverse = arr.reverse()
            console.log(reverse)
            return reverse
        },

        confirmItemSellingStatus(ty) {
            let confirmText = ty === 'assume' ? '인수완료' : '강제처리'
            let _this = this
            this.createConfirm({
                content: confirmText,
                confirm: () => {
                    _this.itemSellingStatus(ty)
                }
            })
        },
        itemSellingStatus(ty) {
            let type = 'auction'
            if (!util.isEmpty(this.itemData.Status.m_type) && this.itemData.Status.m_type === 3) {
                type = 'pricetag'
            }
            let params = {
                i_idx: this.itemData.i_idx,
                type: type,
                m_idx: this.itemData.Status.m_idx
            }
            EventBus.$emit('setItemSellingStatus', ty, params)
        },
        returnBidPrice() {
            let bid_price = this.itemData.Status.m_bid_price
            if (util.isEmpty(bid_price)) {
                let bid = []
                bid = this.itemData.Status.Bids
                return bid[bid.length - 1]?.ab_bids
            } else {
                return bid_price
            }
        },
        hasBids() {
            return !util.isEmpty(this.itemData.Status.Bids)
        },
        awsS3Download(type, name, key, nft) {
            this.runDownloadFileInfo(type, name, key, nft).then(res => {
                if (!res) {
                    this.errorAlert('파일 다운로드에 실패하였습니다.');
                }

            })
        },
        returnCollection(data) {
            if (!util.isEmpty(data.Collection)) {
                return data.Collection.c_title
            }
            return '-'
        }
    },
    watch: {
        'memo': {
            deep: true,
            handler: function (val, oldVal) {
                this.parentChange('memo', this.memo)
            },
        },

    },
}
</script>

<style scoped>

</style>
